/**
 * Application configuration
 * Centralizes all environment variables and API endpoints
 */

const isProduction = process.env.NODE_ENV === 'production';

const API_BASE_URL = isProduction
    ? 'https://server.ilovej1.com/api'
    : 'http://localhost:8080/api';

const config = {
    isProduction,
    api: {
        baseUrl: API_BASE_URL,
        esim: `${API_BASE_URL}/esim`,
        auth: `${API_BASE_URL}/auth`,
        checkout: `${API_BASE_URL}/checkout`,
    }
};

export default config;

